/* Contact-form spam guard — Martin Graphics.
 *
 * The new-store spam wave (session 29) arrives through the contact form:
 * "can I meet the store owner", "do you ship to Ireland". Two cheap traps
 * stop the commodity bots that render the page and fill every field they
 * find, without putting a puzzle in front of a real customer:
 *
 *   1. HONEYPOT — an off-screen input a human never sees and never tabs to.
 *      It carries NO name attribute on purpose, so even if this script
 *      never runs the browser posts nothing extra and the owner's email
 *      stays clean. A bot that fills it identifies itself.
 *   2. TIME TRAP — a form submitted in under MIN_SECONDS was not typed.
 *      The message field is required, so a human is always slower than
 *      this; a script that posts the instant the DOM is ready is not.
 *
 * Both are CLIENT-side, which is the honest limit of a Shopify contact
 * form: nothing here can stop a bot that POSTs straight to /contact
 * without loading the page. Shopify's own reCAPTCHA setting is the
 * server-side answer to those (Settings -> Checkout -> Spam protection).
 *
 * A tripped trap fails QUIETLY — the bot is told nothing, so nobody
 * tunes around it. Real customers cannot reach either branch.
 */
(function () {
  'use strict';

  var MIN_SECONDS = 3;

  function guard(form) {
    if (form.dataset.mgGuarded === 'true') return;
    form.dataset.mgGuarded = 'true';

    var honeypot = form.querySelector('[data-mg-honeypot]');
    var loadedAt = Date.now();

    form.addEventListener('submit', function (event) {
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        return;
      }
      if ((Date.now() - loadedAt) / 1000 < MIN_SECONDS) {
        event.preventDefault();
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-mg-contact-guard]');
    for (var i = 0; i < forms.length; i++) guard(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
